import { ButtonActionType } from '@/components/buttons/Button.types';
import useStore from '@/stores/useStore';

export const useModalButtonActions = () => {
  const { setDemoModalOpen, setTrialModalOpen } = useStore();

  const modalActionHandler = (action?: ButtonActionType) => {
    if (!action) return;

    switch (action) {
      case 'trial':
        setTrialModalOpen(true);
        break;
      case 'demo':
        setDemoModalOpen(true);
        break;

      default:
        break;
    }
  };

  return { modalActionHandler };
};
